var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIconPieColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42951",
    "data-name": "Group 42951",
    transform: "translate(-696 -319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42632",
    "data-name": "Group 42632",
    transform: "translate(696 319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42612",
    "data-name": "Group 42612",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6222",
    "data-name": "Rectangle 6222",
    width: 30,
    height: 30,
    rx: 4,
    fill: "#f45e29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Donut_chart",
    "data-name": "Donut chart",
    transform: "translate(702.689 325.688)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 16,
    height: 16,
    transform: "translate(0.312 0.312)",
    fill: "#e0e0e0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42940",
    "data-name": "Group 42940",
    transform: "translate(-15.689 -15.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42941",
    "data-name": "Group 42941",
    transform: "translate(16 17.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42940-2",
    "data-name": "Group 42940",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70439",
    "data-name": "Path 70439",
    d: "M23.245,36.99a7.245,7.245,0,0,1,0-14.49h.472v6.749h6.749v.472a7.194,7.194,0,0,1-2.124,5.121A7.028,7.028,0,0,1,23.245,36.99Zm-.472-13.5a6.274,6.274,0,1,0,4.909,10.69A6.135,6.135,0,0,0,29.5,30.217H22.773Z",
    transform: "translate(-16 -22.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42943",
    "data-name": "Group 42943",
    transform: "translate(24.33 16.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42942",
    "data-name": "Group 42942",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70440",
    "data-name": "Path 70440",
    d: "M59.017,23.817H51.3V16.1h.472a7.251,7.251,0,0,1,7.245,7.245Zm-6.773-.944h5.805a6.263,6.263,0,0,0-1.817-3.965,6.135,6.135,0,0,0-3.965-1.817v5.782Z",
    transform: "translate(-50.3 -17.1)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIconPieColored);
export default __webpack_public_path__ + "static/media/chart-icon-pie-colored.f72810f7.svg";
export { ForwardRef as ReactComponent };